export const QUOTE_NO_KEY = 'quoteNo'
export const TOTAL_PRICE_KEY = 'totalPrice'
export const ADDONS_LIST_KEY = 'addonsList'
export const ADDONS_PRICE_KEY = 'addonsPrice'
export const ACTIVE_ADDONS_KEY = 'activeAddons'
export const INSURED_TRAVELERS_KEY = 'insuredTravelers'
export const IS_SENT_PURCHASE_ANALYTICS_EVENT = 'isSentPurchaseAnalyticsEvent'
export const PRODUCT_BONUS_KEY = 'productBonus'
export const QUOTE_WITH_COINS_DISCOUNT_KEY = 'quoteWithCoinsDiscount'
export const COINS_DISCOUNT_PRICE_KEY = 'coinsDiscountPrice'
